module.exports = ".topo-modal {\n    margin-top: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/detalhe-evento-processamento/detalhe-evento-processamento.component.css
// module id = ./src/app/detalhe-evento-processamento/detalhe-evento-processamento.component.css
// module chunks = main